// disable this refactoring for now
angular.module('nv.routes.error-pages', []);
